import React from 'react';

import { CmBox, CmFlex, CmText } from '@/components/uiParts';
import { ChevronRightIcon } from '@/components/uiParts';

interface Props {
  description?: string;
  isExpanded: boolean;
  name: string;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const AccordionHeader: React.FC<Props> = ({
  description,
  onClick,
  isExpanded = false,
  name,
}) => {
  return (
    <CmFlex pl={2} w="100%" align="center" position="relative" cursor="pointer">
      <CmBox onClick={onClick} px={4} py={2}>
        <ChevronRightIcon
          transition="0.3s"
          transform={isExpanded ? 'rotate(90deg)' : 'none'}
          fontSize="30px"
        />
      </CmBox>
      <CmFlex
        align="flex-start"
        flex={1}
        direction="column"
        justify="center"
        fontWeight="bold"
        textAlign="left"
        fontSize="lg"
        onClick={onClick}
        py={3}
      >
        <CmBox fontSize="xs" color="gray.500">
          {description}
        </CmBox>
        <CmText>{name}</CmText>
      </CmFlex>
    </CmFlex>
  );
};
